export default __webpack_public_path__ + "static/media/demo-5.ff674129.png";